import { render, staticRenderFns } from "./EmpresaAmbienteIndicator.vue?vue&type=template&id=5a9054b6&scoped=true"
import script from "./EmpresaAmbienteIndicator.vue?vue&type=script&lang=js"
export * from "./EmpresaAmbienteIndicator.vue?vue&type=script&lang=js"
import style0 from "./EmpresaAmbienteIndicator.vue?vue&type=style&index=0&id=5a9054b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9054b6",
  null
  
)

export default component.exports